import type { ResultEvent } from '../../../types/events';

const eventProgressV2SkeletonRowCount = (event: ResultEvent | null | undefined): number =>
  Math.max(1, event?.subEvents?.length ?? 0);

export default eventProgressV2SkeletonRowCount;
